import { Pill, statusChipColors, StatusChipType, SystemIcon, Typography } from '@utmost.co/utmost-design-system';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  border: 1px solid lightgrey;
  border-radius: 5px;
  margin-bottom: 8px ;
  padding: 8px;
`;

export const StyledLinkContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledHeader = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  gap: 2px;
`;

export const StyledPill = styled(Pill)<{ $type?: StatusChipType; $colorType?: StatusChipType }>`
  border-radius: 5px;
  height: 20px;
  background: ${({ $type }) => statusChipColors[$type ?? StatusChipType.GREY].backgroundColor};
  && {
      color: ${({ $type }) => statusChipColors[$type ?? StatusChipType.GREY].color};
  }
`;

export const StyledIcon = styled(SystemIcon)<{ $type?: StatusChipType }>`
  color: ${({ $type }) => ($type ? statusChipColors[$type].color : 'inherit')} !important;
`;

export const StyledDefaultPill = styled(StyledPill)<{ $type?: StatusChipType }>`
  span {
    padding: 0 6px;
  }
`;

export const StyledSkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;

`;

export const StyledLink = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 16px;
  gap: 4px;
  cursor: pointer;
`;

export const StyledLinkTypography = styled(Typography)`
  color: ${({ theme }) => theme.colorPrimary};
`;

export const StyledHeaderTypography = styled(Typography)`
   white-space: nowrap;
`;

export const StyledNoPolicyTypography = styled(Typography)`
  color: ${({ theme }) => theme.colorTextSecondary};
  opacity: 0.5;
`;

export const TruncatedLink = styled(Typography)<{ disabled?: boolean }>`
  max-width: 270px;
  height: fit-content;
  width: fit-content; 
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  color: ${({ theme, disabled }) => (disabled ? theme.colorTextSecondary : theme.colorPrimary)};
  text-decoration: ${({ disabled }) => (disabled ? 'none' : 'underline')};
  margin: 0 2px;
`;
